// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAddressInfoDto
 */
export interface IAddressInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IAddressInfoDto
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IAddressInfoDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof IAddressInfoDto
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IAddressInfoDto
     */
    line3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IAddressInfoDto
     */
    line4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IAddressInfoDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof IAddressInfoDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof IAddressInfoDto
     */
    zipcode: string;
    /**
     * 
     * @type {boolean}
     * @memberof IAddressInfoDto
     */
    undeliverable?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IAddressInfoDto
     */
    country_id: number;
    /**
     * 
     * @type {string}
     * @memberof IAddressInfoDto
     */
    address_type: IAddressInfoDtoAddressTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IAddressInfoDto
     */
    preferred_mailing?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IAddressInfoDto
     */
    preferred_physical?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof IAddressInfoDto
     */
    undeliverable_at?: Date | null;
}

/**
* @export
* @enum {string}
*/
export enum IAddressInfoDtoAddressTypeEnum {
    PO_BOX = 'PO_BOX',
    RESIDENTIAL = 'RESIDENTIAL',
    BUSINESS = 'BUSINESS',
    UNKNOWN = 'UNKNOWN'
}


/**
 * Check if a given object implements the IAddressInfoDto interface.
 */
export function instanceOfIAddressInfoDto(value: object): value is IAddressInfoDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    if (!('country_id' in value) || value['country_id'] === undefined) return false;
    if (!('address_type' in value) || value['address_type'] === undefined) return false;
    return true;
}

export function IAddressInfoDtoFromJSON(json: any): IAddressInfoDto {
    return IAddressInfoDtoFromJSONTyped(json, false);
}

export function IAddressInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAddressInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'line4': json['line4'] == null ? undefined : json['line4'],
        'city': json['city'],
        'state': json['state'],
        'zipcode': json['zipcode'],
        'undeliverable': json['undeliverable'] == null ? undefined : json['undeliverable'],
        'country_id': json['country_id'],
        'address_type': json['address_type'],
        'preferred_mailing': json['preferred_mailing'] == null ? undefined : json['preferred_mailing'],
        'preferred_physical': json['preferred_physical'] == null ? undefined : json['preferred_physical'],
        'undeliverable_at': json['undeliverable_at'] == null ? undefined : (new Date(json['undeliverable_at'])),
    };
}

export function IAddressInfoDtoToJSON(json: any): IAddressInfoDto {
    return IAddressInfoDtoToJSONTyped(json, false);
}

export function IAddressInfoDtoToJSONTyped(value?: IAddressInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'line4': value['line4'],
        'city': value['city'],
        'state': value['state'],
        'zipcode': value['zipcode'],
        'undeliverable': value['undeliverable'],
        'country_id': value['country_id'],
        'address_type': value['address_type'],
        'preferred_mailing': value['preferred_mailing'],
        'preferred_physical': value['preferred_physical'],
        'undeliverable_at': value['undeliverable_at'] === null ? null : ((value['undeliverable_at'] as any)?.toISOString()),
    };
}

